import formSchema from './formSchema'

/**
 * Array de países suportados no formato { value, label }
 * Gerado dinamicamente a partir do formSchema
 */
export const countries = Object.keys(formSchema).map(countryCode => ({
    value: countryCode,
    label: formSchema[countryCode].defaultCountryOption?.label || countryCode
}))

export default countries
